import { Expose } from "class-transformer";
import { Data } from "../data";

@Expose()
export class ExternalAuthenticationData  extends Data<ExternalAuthenticationData> {
  cavv!: string;
  xid!: string;
  eci!: string;
  version!: string;
  referenceID!: string;
}




